/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
import * as dateFns from 'date-fns';

export function formattedDate(date: Date): string {
  return `${date.toLocaleDateString('pt-PT', {
    day: '2-digit',
  })} de ${date.toLocaleDateString('pt-PT', {
    month: 'long',
  })} de ${date.toLocaleDateString('pt-PT', {
    year: 'numeric',
  })} às ${date.toLocaleTimeString('pt-PT').substring(0, 5)}`;
}

export function convertDateToUTC(date: Date): Date {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  );
}

export function addMinutesToDate(date: Date, minutes: number): Date {
  return new Date(date.getTime() + minutes * 60000);
}

export function padWithZeroes(number: number, length: number): string {
  let stringValue = `${String(number).replace(/\D+/g, '')}`;
  while (stringValue.length < length) stringValue = `0${stringValue}`;

  return stringValue;
}

export function addPadWithZeroes(value: number): string {
  return String(value).padStart(2, '0');
}

export function roundTime(hours: number, minutes: number): string {
  const roundMinutes = (parseInt(String((minutes + 7.5) / 15), 10) * 15) % 60;
  const roundHours = minutes > 52 ? (hours === 23 ? 0 : ++hours) : hours;

  return `${addPadWithZeroes(roundHours)}:${addPadWithZeroes(roundMinutes)}`;
}

export function getDateWithoutTimezone(value: Date): Date {
  const formatted = new Date(value);
  formatted.setMinutes(formatted.getMinutes() + formatted.getTimezoneOffset());

  return formatted;
}

export function formattedRegistryDate(date: string): string {
  const dateTimestamp = new Date(date);

  const formatedDate = dateFns.format(dateTimestamp, 'dd/MM/yyyy');

  return formatedDate;
}

export function formattedRegistryHours(date: string): string {
  const dateObject = dateFns.parseISO(date);
  const dateFormated = dateFns.getHours(dateObject);

  const hour = dateFns.getHours(dateFormated);
  const minutes = dateFns.getMinutes(dateFormated);

  return `${addPadWithZeroes(hour)}:${addPadWithZeroes(minutes)}`;
}
